var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"text-left custom-form-group-input",class:_vm.customClass,attrs:{"label":_vm.label,"disabled":_vm.disabled,"label-for":_vm.labelFor}},[_vm._t("default"),(_vm.invalidFeedback)?_c('b-form-invalid-feedback',{attrs:{"id":_vm.feedbackId}},[_vm._v(" "+_vm._s(_vm.invalidFeedback)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }